import {
    GET_WEEKLY_LAUNDRY_REPORT_FAILURE,
    GET_WEEKLY_LAUNDRY_REPORT_SUCCESS,
} from '../constants/MTag';

const initialState = {
    error: false,
    isLoading: false,
    data: {
        result: {},
    },
};

const weeklyLaundryReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WEEKLY_LAUNDRY_REPORT_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                data: action.payload,
            };
        case GET_WEEKLY_LAUNDRY_REPORT_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
                data: { result: {} },
            };
        default:
            return state;
    }
};

export default weeklyLaundryReportReducer;
